import { all, takeLatest } from "redux-saga/effects";
import {
  LOG_LIST,
  LOG_DETAILS,
  DELETE_LOG,
} from "../actions/log.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getLogList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "logs/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* logDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `logs/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteLog({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `logs/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Log() {
  yield all([
    takeLatest(LOG_LIST, getLogList),
    takeLatest(LOG_DETAILS, logDetails),
    takeLatest(DELETE_LOG, deleteLog),
  ]);
}

export default Log;
